import { render, staticRenderFns } from "./boardPush.vue?vue&type=template&id=759f2d79&scoped=true&"
import script from "./boardPush.vue?vue&type=script&lang=js&"
export * from "./boardPush.vue?vue&type=script&lang=js&"
import style0 from "./boardPush.vue?vue&type=style&index=0&id=759f2d79&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "759f2d79",
  null
  
)

export default component.exports